<template>
<div>
    <h4>Logging out...</h4>

</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Logout',
  methods: {
    logout() {
      // const path = '/logout';
      const path = `${this.$hostname}/logout`;
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.status);
          if (res.data.status === 'success') {
            localStorage.clear();
            this.$router.push({ path: '/signup' });
          } else {
            alert('Server error! Please try again!');
            console.log("didn't log out!");
            this.$router.push({ path: '/task' });
          }
        });
    },
  },
  created() {
    this.logout();
  },
};
</script>
